import DoorsMatrix from "../DoorsMatrix";
import buildDoorMatrixData from "../builders/buildDoorMatrixData";
import { TIPO_TREM_FALLBACK } from "../../util/doorLayout";
export default function DoorsSection({
    portasMonitor,
    tipoTrem = TIPO_TREM_FALLBACK
}) {
    return (
        <DoorsMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Portas"
            tipoTrem={tipoTrem}
            topLabels={[
                "Isolada",
                "Condenada",
                "Falha",
                "Aberta",
                "Fechada e travada"
            ]}
            bottomLabels={[
                "Fechada e travada",
                "Aberta",
                "Falha",
                "Condenada",
                "Isolada"
            ]}
            matrixData={
                buildDoorMatrixData(
                    portasMonitor,
                    tipoTrem
                )
            }
        />
    );
}
